import Palette from './Palette';

export default {
  __init__: [
    'tokenSimulationPalette'
  ],
  tokenSimulationPalette: [ 'type', Palette ]
};